

<section role="main">
    <form #form="ngForm" validateOnSubmit id="novaSenha-form" class="form-signin" role="form">
        <h2 class="form-signin-heading">Prefeitura Municipal de Vitória</h2>
        <pmv-loading [isLoading]="loading"></pmv-loading>

        <div *ngIf="mostrarCPFNascimento" class="form-signin" role="form">
            <p>Informe seu CPF e a Data de Nascimento.</p>

            <div class="form-group username">
                <pmv-input-text [(ngModel)]="cpf" name="login" type="text" label="CPF*">
                </pmv-input-text>
            </div>
            <br />
            <div class="form-group username">
                <pmv-datepicker [(ngModel)]="dataDeNascimento" name="dataNascimento" label="Data de Nascimento*"
                    [showTime]="false">
                </pmv-datepicker>
            </div>

            <button name="btnDadosIniciais" [disabled]="consultando" type="button"
                class="btn btn-lg btn-primary btn-block" style="position: relative" (click)="validarPessoa()">
                Prosseguir
            </button>

        </div>

        <div *ngIf="mostrarPerguntaAleatoria" class="form-signin" role="form">
            <p>Responda a pergunta.</p>

            <pmv-dropdown [(ngModel)]="perguntaAleatoria.resposta" [label]="pergunta" name="respota"
                [options]="perguntaOptions" optionLabelField="descricao" optionValueField="descricao" defaultOption=" "
                class="ui-dropdown-new" id='ddlPerguntaRespostas'>
            </pmv-dropdown>

            <button name="btnPergunta" [disabled]="consultando" type="button" class="btn btn-lg btn-primary btn-block"
                style="position: relative" (click)="validarResposta()">
                Prosseguir
            </button>
        </div>


        <div *ngIf="mostrarNovaSenhaHeConfirmacao" class="form-signin" role="form">
            <p>Informe a nova Senha.</p>
            <pmv-input-text [(ngModel)]="novaSenha" name="password" placeholder="Senha" type="password"
                label="Nova Senha*">
            </pmv-input-text>
            <br />
            <pmv-input-text [(ngModel)]="confirmaNovaSenha" name="confirmPassword" placeholder="Confirmação"
                type="password" label="Confirmação de Nova Senha*">
            </pmv-input-text>

            <button [disabled]="consultando" type="button" class="btn btn-lg btn-primary btn-block"
                style="position: relative" (click)="alterarSenha()">
                Alterar Senha
            </button>
        </div>

    </form>
</section>


// WEBPACK FOOTER //
// ./src/app/pages/login/senha/recuperar-senha.component.html